const FooterSection = () => {
  return (
    <div className="w-screen border border-t-white flex bg-primary-background-color py-4 items-center justify-center">
      <p className="text-white text-sm">Build it with ❤️ by Osanda Adithya (Me)</p>
    </div>
  );
};

export default FooterSection;
